import React from 'react';
import PersonIcon from '@material-ui/icons/Person';
import CodeIcon from '@material-ui/icons/Code';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ListAltIcon from '@material-ui/icons/ListAlt';
import DoneAllIcon from '@material-ui/icons/DoneAll';

export const ONBOARDING_STEPS = [
  { id: 1, icon: <PersonIcon />, title: 'Client ID Creation', desc: 'Create an AC, CC, or Pseudo user client.' },
  { id: 2, icon: <CodeIcon />, title: 'Validate Client ID via Token Generation', desc: 'Receive IAM credentials and generate your first token.' },
  { id: 3, icon: <AssignmentIcon />, title: 'Prerequisites & Requirement Gathering', desc: 'Gather your business case, entitlements, and APIGEE configuration details before submission.' },
  { id: 4, icon: <ListAltIcon />, title: 'Request Form', desc: 'Submit your onboarding request via PowerApps and track its status.' },
  { id: 5, icon: <DoneAllIcon />, title: 'Validation of API Access', desc: 'Validate API access with a live call.' },
];
